export default __webpack_public_path__ + "static/media/smartShopper.3785db2d.JPG";